import React from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'

function Terms() {
  return (
    <div>
        <Header></Header>
        <h1 style={{ marginTop: '68px' }}>Terms and Conditions</h1>
        <Footer></Footer>
    </div>
  )
}

export default Terms